import styles from './SpyLaunchFinishedNotification.module.css'
import { useState } from 'react';
import { DateTime } from 'luxon';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

type SpyLaunchFinishedNotificationProps = {
    notificationLog: any,
    loading?: boolean,
}

export const SpyLaunchFinishedNotification = (props: SpyLaunchFinishedNotificationProps): JSX.Element => {
    const {
        notificationLog,
        loading = false
    } = props;
    const [notification, setNotification] = useState<any | null>(null);

    useEffect(() => {
        if (notificationLog === undefined) {
            return
        }

        const data: any = JSON.parse(notificationLog.data);

        const message = (
            <div className={styles.SpyLaunchFinishedNotification__Card}>
                <div className={styles.SpyLaunchFinishedNotification__Title}>{data.MonitorTitle}.</div> 
                <div className={styles.SpyLaunchFinishedNotification__Value}>Price changed. Avg: {`$${Math.round(data.FirstDayMedian)}`}</div>          
            </div>
        );

        const notification = {
            title: `Airbnb Alert!`,
            date: DateTime.fromISO(notificationLog.dateTimeUtc).toFormat('M/dd/yyyy'),
            time: DateTime.fromISO(notificationLog.dateTimeUtc).toFormat('hh:mm a'),
            message: message,
            data: data,
        }

        setNotification(notification);
    }, [
        notificationLog
    ])

    if (notification === null) {
        return (<></>);
    }

    return (
        <Link
            className={styles.SpyLaunchFinishedNotification__Link}
            to={`/market?spyId=${notification.data.MonitorId}`}
        >
            <div className={styles.SpyLaunchFinishedNotification}>
                <div
                    className={styles.SpyLaunchFinishedNotification__Header}
                >
                    <div className={styles.SpyLaunchFinishedNotification__Heading1}>
                        {notification.title}
                    </div>
                    <div className={styles.SpyLaunchFinishedNotification__DateTimeContainer}>
                        <div className={styles.SpyLaunchFinishedNotification__Date}>
                            {notification.date}
                        </div>
                        <div className={styles.SpyLaunchFinishedNotification__Time}>
                            {notification.time}
                        </div>
                    </div>
                </div>
                <hr className={styles.SpyLaunchFinishedNotification__HeaderDivider}></hr>
                <div>
                    <div className={styles.SpyLaunchFinishedNotification__Message}>
                        {notification.message}
                    </div>
                </div>
                <div className={styles.SpyLaunchFinishedNotification__SeeMoreContainer}>
                    <div className={styles.SpyLaunchFinishedNotification__SeeMore}>
                        See more
                    </div>
                </div>
            </div>
        </Link>
    )
}
